// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconFolderShare } from '@tabler/icons-react';

// constant
const icons = {
    IconFolderShare
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const assetsManagement = {
    id: 'security-group',
    type: 'group',
    title: <FormattedMessage id="assets_management" />,
    children: [
        {
            id: 'all_assets',
            title: <FormattedMessage id="all_assets" />,
            type: 'item',
            url: '/loolu/admin/assets-management',
            icon: icons.IconFolderShare,
            external: false,
            breadcrumbs: false
        }
    ]
};

export default assetsManagement;
